import { columnStyle } from './column';
import { headerStyle } from './header';
import { footerStyle } from './footer';
import { rowStyle } from './row';
import { cellStyle } from './cell';
import { groupStyle } from './group';
import { scrollbarStyle } from './scrollbar';
import { overlapStyle } from './overlap';

export const gridFlexStyle = ({ palette = {} }) => ({
  '.bingadsgrid .flex-layout': {
    ...columnStyle({ palette }),
    ...headerStyle({ palette }),
    ...footerStyle({ palette }),
    ...rowStyle({ palette }),
    ...cellStyle({ palette }),
    ...groupStyle({ palette }),
    ...overlapStyle({ palette }),
    ...scrollbarStyle({ palette }),
  },
});
